import React from "react";
import 'chart.js/auto';
import { Pie } from "react-chartjs-2";

const  PieChart = (props ) => {


  return (
    <div className="chart-container">
       <Pie
        data={props.chartData}
        options={{
          plugins: {
            title: {
              display: true,
              text: props.header
            }
          }
        }}
      /> 
      
    </div>
  );
}
export default PieChart;